import React from 'react';
import { AppContext } from '../AppContext';

const Statistics = (props) => {
    const app = React.useContext(AppContext);
    const userdata = app.userdata;
    

    const levels = ["Easy", "Medium", "Hard", "CrazyNinja"];
    const categories = Object.entries({
        gamesPlayed: "Matches Played",
        win: "Wins",
        win_rate: "Wins Rate",
        win_streak: "Win Streak",
        win_streak_max: "Win Streak Max",
        loss_streak: "Loss Streak",
        round_played: "Rounds Played",
        roundOpponent_played: "Rounds Played (Opponent)",
        round_win: "Rounds Won",
        roundOpponent_win: "Rounds Won (Opponent)",
        round_loss: "Rounds Lost",
        roundOpponent_loss: "Rounds Lost (Opponent)",
        round_points: "Points",
        roundOpponent_points: "Points (Opponent)",
        round_win_points_avg: "Points Win Avg",
        roundOpponent_win_points_avg: "Points Win Avg (Opponent)",
        round_deadwood: "Deadwood",
        roundOpponent_deadwood: "Deadwood (Opponent)",
        round_gin: "Gin",
        roundOpponent_gin: "Gin (Opponent)",
        round_bigGin: "Big Gin",
        roundOpponent_bigGin: "Big Gin (Opponent)",
        round_undercut: "Undercut",
        roundOpponent_undercut: "Undercut (Opponent)",
        round_points_avg: "Points Avg",
        roundOpponent_points_avg: "Points Avg (Opponent)",
        round_deadwood_avg: "Deadwood Avg",
        roundOpponent_deadwood_avg: "Deadwood Avg (Opponent)",
        round_gin_avg: "Gin Avg",
        roundOpponent_gin_avg: "Gin Percent (Opponent)",
        round_bigGin_avg: "Big Gin Percent",
        roundOpponent_bigGin_avg: "Big Gin Percent (Opponent)",
        round_undercut_avg: "Undercut Percent",
        roundOpponent_undercut_avg: "Undercut Percent (Opponent)",
        round_deadwood_max: "Deadwood Max",
        round_points_max: "Points Max",
        round_points_last: "Points Last",
    });


    //const levelsPossible = ["Easy", "Medium", "Hard", "CrazyNinja"];
    // //filter out levels not played
    // let levels = [];
    // for (let i = 0; i < levelsPossible.length; i++) {
    //     let level = levelsPossible[i];
    //     if (userdata["gamesPlayed_" + level]) levels.push(level);
    // }

    const headerRow = (
        <thead>
            <tr>
                <th key="Catagory">Catagory</th>
                {levels.map((level) => (
                    <th key={level} >{level}</th>
                ))}
            </tr>
        </thead>
    );


    const itemRows = categories.map(([key, name]) => {
        return (
            <tr key={key}>
                <td >{name}</td>
                {levels.map((level) => {
                    const statKey = key + "_" + level;
                    const value = userdata[statKey] || 0;
                    return (
                        <td key={statKey} >{value}</td>
                    )
                })
                }

            </tr>
        )

    });
    return (

        <div id="Stats1" className="page1">
            <div className="xwrapper">
                <div className="pageTitle">
                    <a className="backButton" href="#"></a>
                    <h1>Stats</h1>
                </div>
                <table className='statsTable'>
                    {headerRow}
                    <tbody>
                        {itemRows}
                    </tbody>

                </table>
            </div>
        </div>
    )
};

export default Statistics;

